import { render } from "./SideMenu.vue?vue&type=template&id=27cd3bc2&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=27cd3bc2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cd3bc2"]])

export default __exports__